import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-job-posting-card',
    templateUrl: './indeed-job-posting-card.template.html',
})
export class IndeedJobPostingCardComponent {
    @Input() isIndeedJobSyncEnabled = true;
    @Output() isIndeedJobSyncEnabledChange: EventEmitter<boolean> = new EventEmitter<boolean>();
}
